// Fetch histogram data
export async function fetchHistogram(query, { StartDate, EndDate }) {
  const params = {
    StartDate: StartDate,
    EndDate: EndDate,
    Query: query,
  };

  const url = `https://ai.oigetit.com/AI71/Histogram?json=${encodeURIComponent(JSON.stringify(params))}`;

  try {
    console.log('Fetching from URL:', url);
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    
    if (!res.ok) {
      throw new Error(`API Error: ${res.status} - ${res.statusText}`);
    }
    
    const data = await res.json();
    console.log('Received data:', data);
    
    if (!Array.isArray(data)) {
      throw new Error('Invalid data format received from API');
    }

    // Transform the data to match the expected format for the chart
    return data.map(item => ({
      Date: item.pubdate,
      Count: item.volume,
      volume_pos: item.volume_pos,
      volume_neg: item.volume_neg,
      volume_neu: item.volume_neu,
      sentiment: item.sentiment,
      political_bias: item.political_bias,
      trusted: item.trusted
    }));
  } catch (error) {
    console.error('fetchHistogram error:', error);
    throw new Error(`Failed to fetch histogram data: ${error.message}`);
  }
}

// Fetch articles data
export async function fetchArticles(query, { StartDate, EndDate }) {
  const params = {
    StartDate: StartDate,
    EndDate: EndDate,
    Query: query,
  };

  const url = `https://ai.oigetit.com/AI71/Articles?json=${encodeURIComponent(JSON.stringify(params))}`;

  try {
    console.log('Fetching articles from URL:', url);
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    
    if (!res.ok) {
      throw new Error(`API Error: ${res.status} - ${res.statusText}`);
    }
    
    const data = await res.json();
    console.log('Received articles data:', data);
    
    if (!data.result || !Array.isArray(data.result)) {
      throw new Error('Invalid data format received from API');
    }

    // Transform the data to include all necessary fields
    return data.result.map(item => ({
      Title: item.title,
      Description: item.description,
      Date: item.pubdate,
      UrlLink: item.urllink,
      Feed: item.feed,
      Trusted: item.trusted,
      Happiness: item.happiness,
      PoliticalBias: item.politicalbias,
      ImageLink: item.imagelink,
      VideoLink: item.videolink
    }));
  } catch (error) {
    console.error('fetchArticles error:', error);
    throw new Error(`Failed to fetch articles: ${error.message}`);
  }
}

// Fetch country data
export async function fetchCountryData(query, { StartDate, EndDate }) {
  const params = {
    StartDate: StartDate,
    EndDate: EndDate,
    Query: query,
  };

  const url = `https://ai.oigetit.com/AI71/Country?json=${encodeURIComponent(JSON.stringify(params))}`;

  try {
    console.log('Fetching country data from URL:', url);
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    
    if (!res.ok) {
      throw new Error(`API Error: ${res.status} - ${res.statusText}`);
    }
    
    const data = await res.json();
    console.log('Received country data:', data);
    
    // Check if we have valid data
    if (!data || !Array.isArray(data)) {
      throw new Error('Invalid data format received from API');
    }

    // Transform the data to match our expected format
    return data.map(item => ({
      Country: item.country || 'Unknown',
      Volume: item.volume || 0,
      PoliticalBias: item.political_bias || 0,
      Sentiment: item.sentiment || 0,
      // Add country name mapping
      CountryName: getCountryName(item.country)
    }));
  } catch (error) {
    console.error('fetchCountryData error:', error);
    throw new Error(`Failed to fetch country data: ${error.message}`);
  }
}

// Helper function to get country name from country code
function getCountryName(countryCode) {
  const countryNames = {
    'AE': 'United Arab Emirates',
    'SA': 'Saudi Arabia',
    'QA': 'Qatar',
    'KW': 'Kuwait',
    'BH': 'Bahrain',
    'OM': 'Oman',
    'EG': 'Egypt',
    'JO': 'Jordan',
    'LB': 'Lebanon',
    'IQ': 'Iraq',
    'SY': 'Syria',
    'YE': 'Yemen',
    'PS': 'Palestine',
    'IL': 'Israel',
    'TR': 'Turkey',
    'IR': 'Iran',
    // Add more country codes as needed
  };
  return countryNames[countryCode] || countryCode;
}
